{
  "panel": {
    "label": "Filter",
    "resetAll": "Reset all",
    "resetCount": "Reset all ({count})",
    "more": "More filters"
  },
  "fields": {
    "name": "Name",
    "namePlaceholder": "Search rider...",
    "country": "Country",
    "countryAll": "All countries",
    "valueRange": "Value CZ$ (min-max)",
    "salaryRange": "Salary CZ$ (min-max)",
    "ageRange": "Age (min-max)",
    "bidRange": "Highest bid CZ$ (min-max)",
    "askingPriceRange": "Asking price CZ$ (min-max)",
    "valueDeviationRange": "Value deviation % (min-max)",
    "team": "Team",
    "teamAll": "All teams",
    "min": "Min",
    "max": "Max",
    "contractBy": "Contract expires by season",
    "contractAny": "Any contract",
    "contractNone": "No contract",
    "contractSeason": "Season {season}"
  },
  "toggles": {
    "freeAgent": "Free agent",
    "u25": "U25",
    "u23": "U23",
    "showAi": "Show AI teams"
  },
  "stats": {
    "section": "Stat filters",
    "active": "{count} active",
    "minInput": "{label} min",
    "maxInput": "{label} max"
  },
  "chips": {
    "value": {
      "min": "Value ≥ {amount} CZ$",
      "max": "Value ≤ {amount} CZ$"
    },
    "salary": {
      "min": "Salary ≥ {amount} CZ$",
      "max": "Salary ≤ {amount} CZ$"
    },
    "age": {
      "min": "Age ≥ {value}",
      "max": "Age ≤ {value}"
    },
    "bid": {
      "min": "Bid ≥ {amount} CZ$",
      "max": "Bid ≤ {amount} CZ$"
    },
    "askingPrice": {
      "min": "Price ≥ {amount} CZ$",
      "max": "Price ≤ {amount} CZ$"
    },
    "valueDeviation": {
      "min": "Deviation ≥ {value}%",
      "max": "Deviation ≤ {value}%"
    },
    "teamSelected": "Team selected",
    "statRange": "{label} {min}-{max}",
    "remove": "Remove filter: {label}",
    "contract": {
      "by": "Contract ≤ season {season}",
      "none": "No contract"
    }
  }
}
